import MyService from '../../service';

const ArticleApi = {
  index: async () => {
    try {
      const { data } = await MyService.getRequestData('/articles');

      return data || [];
    } catch (error) {
      console.error(error);
      return [];
    }
  },
  detail: async (id, language) => {
    try {
      const { data } = await MyService.getRequestData(
        `/articles/${id}/${language}`
      );

      return data || null;
    } catch (error) {
      console.error(error);
      return null;
    }
  },
  create: async (param) => {
    try {
      const { data } = await MyService.postRequestData(`/articles`, param);

      return data || null;
    } catch (error) {
      console.error(error);
      return null;
    }
  },
  edit: async (id, language, param) => {
    try {
      const { data } = await MyService.putRequestData(
        `/articles/${id}/${language}`,
        param
      );

      return data || null;
    } catch (error) {
      console.error(error);
      return null;
    }
  },
  publish: async (id) => {
    try {
      const { data } = await MyService.putRequestData(
        `/articles/publish/${id}`
      );

      return data || null;
    } catch (error) {
      console.error(error);
      return null;
    }
  },
  unPublish: async (id) => {
    try {
      const { data } = await MyService.putRequestData(
        `/articles/unPublish/${id}`
      );

      return data || null;
    } catch (error) {
      console.error(error);
      return null;
    }
  },
};

export default ArticleApi;
